"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseFilter = void 0;
const defaultLabel_1 = require("../../utils/defaultLabel");
const defaultTestId_1 = require("../../utils/defaultTestId");
/**
 * Provides behavior common to most filters.
 *
 * Note that we don't export this outside of beam; downstream projects can still
 * implement their own filters using the `Filter` interface, but just to keep OO
 * coupling to a minimum, we treat this base class as an internal implementation
 * detail.
 */
class BaseFilter {
    constructor(key, props) {
        this.key = key;
        this.props = props;
    }
    get label() {
        return this.props.label || (0, defaultLabel_1.defaultLabel)(this.key);
    }
    get defaultValue() {
        return this.props.defaultValue;
    }
    testId(tid) {
        return tid[(0, defaultTestId_1.defaultTestId)(this.label)];
    }
}
exports.BaseFilter = BaseFilter;
